import { render, staticRenderFns } from "./MatchingProcess.vue?vue&type=template&id=64d95589"
import script from "./MatchingProcess.vue?vue&type=script&lang=js"
export * from "./MatchingProcess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports